import { lazy } from 'react';
import PageView from './PageView';

const SetantaActivationsPage = lazy(() => import('src/pages/setantaActivations'));

export const setantaActivationsRoutes = [
  {
    path: 'setanta-activations',
    element: <PageView permission="BO_CAN_VIEW_VENDOR_INFO" />,
    children: [{ element: <SetantaActivationsPage />, index: true }],
  },
];
